import React, { useContext } from 'react';

export interface Store {
  v4SupportedAsset: any;
  setV4SupportedAsset: Function;
}

const store: Store = {
  v4SupportedAsset: undefined,
  setV4SupportedAsset: () => {},
};

const V4Context = React.createContext(store);
V4Context.displayName = 'V4 Context';
export const useV4Context = () => useContext(V4Context);
export default V4Context;
